import React from "react";
import { ListChecks } from "lucide-react";

export function StepInstructions({ children }) {
  return (
    <div data-testid="step-instructions" className="flex items-start gap-3 border-l-2 border-[#E2E30A] bg-[#E2E30A]/[0.06] px-4 py-3 mb-8 no-print">
      <ListChecks className="h-4 w-4 text-[#E2E30A] shrink-0 mt-0.5" />
      <div>
        <p className="text-[10px] uppercase tracking-[0.2em] text-[#E2E30A] mb-1">What to do</p>
        <p className="text-sm text-zinc-200 leading-relaxed">{children}</p>
      </div>
    </div>
  );
}

export function SectionHeading({ eyebrow, title, desc }) {
  return (
    <div className="mb-8">
      {eyebrow && <p className="text-xs tracking-[0.25em] uppercase text-[#E2E30A] mb-2">{eyebrow}</p>}
      <h2 className="font-display font-bold text-3xl sm:text-4xl uppercase tracking-tight text-white leading-none">{title}</h2>
      {desc && <p className="text-zinc-200 text-sm mt-3 tracking-wide max-w-2xl">{desc}</p>}
    </div>
  );
}

export function StatTile({ label, value, unit, accent = "", testId, dense = false, info = null }) {
  return (
    <div data-testid={testId} className="border border-white/10 bg-[#141414] p-4">
      <p className="text-[10px] font-semibold tracking-[0.2em] uppercase text-zinc-200 flex items-center gap-1.5">
        <span>{label}</span>
        {info}
      </p>
      <p
        className={`font-display font-bold mt-1 leading-none break-words ${dense ? "text-lg sm:text-2xl" : "text-3xl"} ${accent ? "" : "text-white"}`}
        style={accent ? { color: accent } : undefined}
      >
        {value}
        {unit && <span className="text-sm text-zinc-200 ml-1 font-sans font-medium">{unit}</span>}
      </p>
    </div>
  );
}

export function Chip({ active, onClick, children, testId }) {
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={onClick}
      className={`px-3 py-1.5 text-xs uppercase tracking-wider border transition-colors ${
        active
          ? "bg-[#E2E30A] border-[#E2E30A] text-black font-semibold"
          : "bg-transparent border-white/15 text-zinc-300 hover:border-white/40 hover:text-white"
      }`}
    >
      {children}
    </button>
  );
}

export function FieldLabel({ children, info }) {
  return (
    <label className="text-xs tracking-[0.15em] uppercase text-[#E2E30A] flex items-center gap-1.5 mb-2">
      <span>{children}</span>
      {info || null}
    </label>
  );
}
